import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCars } from "../store/car/actions/actionsCreators";
import Skeleton from "react-loading-skeleton";
import { LuImageOff } from "react-icons/lu";
import CarPurchaseModel from "../Models/CarPurchaseModel";
const Url = process.env.REACT_APP_SERVER_URL;

const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 1440 }, items: 4 },
  largeDesktop: { breakpoint: { max: 1440, min: 1024 }, items: 3 },
  desktop: { breakpoint: { max: 1024, min: 768 }, items: 2 },
  tablet: { breakpoint: { max: 768, min: 480 }, items: 1 },
  mobile: { breakpoint: { max: 480, min: 0 }, items: 1 },
};

const ProductSlider = () => {
  const { carsData, isLoading } = useSelector((state) => state.car);
  const [show, setShow] = useState(false);
  const [carTitle, setCarTitle] = useState("");
  const truncateWords = (text, count) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > count
      ? words.slice(0, count).join(" ") + "..."
      : text;
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCars());
  }, [dispatch]);
  const navigate = useNavigate();
  return (
    <>
      <div className="container my-4">
        <div className="row justify-content-center">
          <div className="col-xl-5 col-lg-6">
            <div className="title-area text-center">
              <span className="sub-title">
                Find the perfect vehicle for your needs.
              </span>
              <h2 className="sec-title">
                Explore Our Featured Vehicles{" "}
                <img
                  className="title-bg-shape shape-center"
                  src="assets/img/bg/title-bg-shape.png"
                  alt="Silverline"
                />
              </h2>
            </div>
          </div>
        </div>
      </div>
      {carsData?.data?.docs?.length > 0 ? (
        <Carousel
          responsive={responsive}
          arrows={true}
          infinite={true}
          autoPlay={true}
          keyBoardControl={true}
          className="mb-5"
        >
          {isLoading
            ? Array.from({ length: carsData?.data?.docs?.length }).map(
                (_, index) => (
                  <div
                    key={index}
                    className="showroom-card style-shadow pt-0 mx-4 "
                  >
                    <div className="showroom-card_img">
                      <Skeleton height={200} />
                    </div>
                    <div className="showroom-card_content">
                      <h4 className="showroom-card_title h5 mt-2">
                        <Skeleton width={120} height={20} />
                      </h4>
                      <p className="showroom-card_text">
                        <Skeleton width={200} height={15} />
                      </p>
                      <div className="price-box">
                        <p className=" me-2">
                          <Skeleton width={80} height={20} />
                          <Skeleton width={60} height={20} />
                        </p>
                        <p>
                          <Skeleton width={80} height={20} />
                          <Skeleton width={60} height={20} />
                        </p>
                      </div>
                      <div className="row g-2 mt-3">
                        {Array.from({ length: 6 }).map((_, i) => (
                          <p className="col-6 mb-0 fw-medium" key={i}>
                            <Skeleton width={100} height={15} />
                          </p>
                        ))}
                      </div>
                      <div className="text-center">
                        <Skeleton width={150} height={40} />
                        <Skeleton width={150} height={40} className="ms-2" />
                      </div>
                    </div>
                  </div>
                )
              )
            : carsData?.data?.docs?.map((item, index) => (
                <div
                  key={index}
                  className="showroom-card style-shadow pt-0 mt-5 mx-4"
                >
                  <div className="showroom-card_img position-relative ">
                    {item.isSold && (
                      <div className="sold-badge position-absolute">Sold</div>
                    )}
                    {item?.featuredImage ? (
                      <img
                        style={{
                          width: "100%",
                          height: "400px",
                        }}
                        src={`${Url}/${item?.featuredImage}`}
                        alt="Featured Car"
                        className="object-cover rounded-lg shadow-lg"
                      />
                    ) : (
                      <div className="flex items-center justify-center w-full h-[400px] bg-gray-200 rounded-lg">
                        <LuImageOff className="w-20 h-20 text-gray-500" />
                        <p className="text-gray-500 mt-2">No Image Available</p>
                      </div>
                    )}
                  </div>
                  <div className="showroom-card_content">
                    <h4
                      onClick={() => navigate(`/car-details/${item._id}`)}
                      className="showroom-card_title h5 mt-2 text-truncate cursor-pointer"
                      style={{
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {truncateWords(item?.title, 4)}
                    </h4>
                    <div className="price-box justify-content-start ">
                      <p className="btn style2 me-2 d-flex gap-2">
                        <div>Price</div>
                        <div>£{item?.carPrice}</div>
                      </p>
                    </div>
                    <p className="showroom-card_text">
                      {item?.shortdescription}
                    </p>

                    <div className="row g-2 ">
                      <p className="col-6 mb-0 fw-medium">
                        Color: <span>{item?.color}</span>
                      </p>
                      <p className="col-6 mb-0 fw-medium">
                        Year: <span>{item?.modalYear}</span>
                      </p>
                      <p className="col-6 mb-0 fw-medium">
                        Engine: <span>{item?.enginePower}</span>
                      </p>
                      <p className="col-6 mb-0 fw-medium">
                        Mileage: <span>{item?.miles}</span>
                      </p>
                      <p className="col-6 mb-0 fw-medium">
                        Gearbox: <span>{item?.gearTypes}</span>
                      </p>
                      <p className="col-6 mb-0 fw-medium">
                        Fuel: <span>{item?.fuelTypes}</span>
                      </p>
                    </div>
                    {!item.isSold ? (
                      <div className="mt-3">
                        <button
                          onClick={() => {
                            setShow(true);
                            setCarTitle(item?.title);
                          }}
                          className="btn style2 p-3"
                        >
                          Buy Now
                        </button>
                      </div>
                    ) : (
                      <div className="mt-3">
                        <button className="btn style2 p-3">Sold</button>
                      </div>
                    )}
                  </div>
                </div>
              ))}
        </Carousel>
      ) : (
        <div className="col-12">
          <div className="showroom-card style-shadow pt-0">
            <div className="showroom-card_content text-center">
              <h4 className="showroom-card_title h5 mt-2">No Cars Available</h4>
              <p className="showroom-card_text">
                Please check back later or explore our other categories.
              </p>
            </div>
          </div>
        </div>
      )}
      <CarPurchaseModel
        carTitle={carTitle}
        showModal={show}
        setShowModal={setShow}
      />
    </>
  );
};

export default ProductSlider;
